export default __webpack_public_path__ + "static/media/sequence_apple.a3d5c8ef.png";